var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDAhuSignalRoomUnit = function SvgDAhuSignalRoomUnit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 684 480",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    points: "341,54 609,54 609,56 341,56",
    fill: "#1C9D5B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 607,
    y: 56,
    width: 2,
    height: 8,
    fill: "#1C9D5B"
  }))));
};
export default SvgDAhuSignalRoomUnit;